import AxiosDefaultRequestConfig from './AxiosDefaultRequestConfig';
import AxiosPostProcessor from './AxiosPostProcessor';
import Axios, { AxiosResponse } from 'axios';
import ResetPasswordRequest from '@/ResetPasswordRequest';
import ResetPasswordInfo from '@/ResetPasswordInfo';
import QueryStringUtility from './QueryStringUtility';
import RecaptchaProtectedResponse from './RecaptchaProtectedResponse';

export class ResetPasswordServiceStatic {
    requestResetToken(model: ResetPasswordInfo): Promise<AxiosResponse<RecaptchaProtectedResponse>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/requestpasswordresetcode`
        return AxiosPostProcessor.postProcess(Axios.post<RecaptchaProtectedResponse>(url, model, AxiosDefaultRequestConfig.merge({ })));
    }

    resetPasswordInfo(code: string): Promise<AxiosResponse<ResetPasswordInfo>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/resetpasswordinfo${QueryStringUtility.getQueryString({code})}`
        return AxiosPostProcessor.postProcess(Axios.get<ResetPasswordInfo>(url, AxiosDefaultRequestConfig.merge({ })));
    }

    setPassword(model: ResetPasswordRequest): Promise<AxiosResponse> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/setpassword`
        return AxiosPostProcessor.postProcess(Axios.post(url, model, AxiosDefaultRequestConfig.merge({ })));
    }
}
const ResetPasswordService = new ResetPasswordServiceStatic();
export default ResetPasswordService;
